<template>
  <div id="email-index" :class="{loaded: !loading, 'container-xxl': true}">
    <InboxScreen          v-if="viewState === ViewStateEnum.INBOX"/>
    <ViewScreen           v-if="viewState === ViewStateEnum.VIEW"/>
    <ReplyOrForwardScreen v-if="viewState === ViewStateEnum.REPLY_OR_FORWARD"/>
    <CreateScreen         v-if="viewState === ViewStateEnum.CREATE"/>
    <MatchScreen          v-if="viewState === ViewStateEnum.MATCH"/>
    <ShowSingleScreen     v-if="viewState === ViewStateEnum.SHOW_SINGLE"/>
  </div>
</template>

<script>
import ViewStateEnum from "./enums/ViewStateEnum";
import store from "../../store";
import emailModule from "./store";
import InboxScreen from './screens/Inbox.vue'
import ViewScreen from './screens/View.vue'
import ReplyOrForwardScreen from './screens/ReplyOrForward.vue'
import CreateScreen from './screens/Create.vue'
import MatchScreen from './screens/Match.vue'
import ShowSingleScreen from './screens/ShowSingle.vue'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "EmailOverview.vue",
  components: {
    InboxScreen,
    ViewScreen,
    ReplyOrForwardScreen,
    CreateScreen,
    MatchScreen,
    ShowSingleScreen,
  },
  props:{
    showSingle: {
      value: Boolean
    }
  },
  created(){
    if (!store.hasModule('email')) store.registerModule('email', emailModule);
  },
  mounted(){
    setTimeout(() => {
      this.initialiseStore();
      if ( this.showSingle) this.showSingleEmail(this.emailId);
    }, 200); // timeout for the main store to initialize with userId
    window.addEventListener('popstate', this.handlePopState);
    this.handlePopState({});
  },
  methods:{
    ...mapActions('email', [
      'initialiseStore',
      'showSingleEmail',
      'showInbox'
    ]),
    handlePopState(e){
      setTimeout(() => {
        const dashboardEmailRoute = window.location.pathname.includes("/dashboard/email");
        if ( dashboardEmailRoute ){
          if (!e.state?.view){
            window.history.replaceState({view: ViewStateEnum.INBOX}, "");
          } else {
            this.showInbox();
          }
        }
      }, 200);
    }
  },
  computed: {
    ...mapGetters('email', [
      "viewState",
      "loading"
    ]),
    ViewStateEnum(){
      return ViewStateEnum;
    },
    emailId(){
      return this.$route.params?.emailId;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
  #email-index {
    display: flex;
    flex: 1;
    margin-bottom: -$spacing-lg;
  }
</style>
